const postalCodesModel = vm => ({
  title: vm.$gettext('Postal Codes'),
  endpoint: 'postal-codes',
  allowNew: true,
  countrize: 'country',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'code',
      label: vm.$gettext('Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Postal code')
    },
    {
      key: 'country',
      label: vm.$gettext('Country'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Country ISO code'),
      type: 'select',
      options: 'countries',
      showKey: 'iso_code',
      showField: 'name',
      withSelect: true
    },
    {
      key: 'reference_address',
      label: vm.$gettext('Reference Address'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Reference address for this postal code')
    },
    {
      key: 'reference_google_place_id',
      label: vm.$gettext('Reference Google Place ID'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Google place ID for the reference address')
    }
  ],
  filters: ['code', 'country', 'reference_address']
})

export default postalCodesModel
